// extracted by mini-css-extract-plugin
module.exports = {"filterItem":"RestaurantSearchFilters_filterItem__aZEoj"};